import { Component, Input, EventEmitter, Output } from "@angular/core";
import { ActiveControlledMedicationOptions } from "../../../api";
import OrderTypeEnum = ActiveControlledMedicationOptions.OrderTypeEnum

@Component({
    selector: 'my-order-type-page',
    templateUrl: 'order-type-page.component.html',
    styleUrls: ['../active-controlled-medications-modal.component.scss']
})
export class OrderTypePage {
    @Input() includeGabapentin: boolean;
    @Input() selectedOrderType: OrderTypeEnum;
    @Output() includeGabapentinChange = new EventEmitter<boolean>();
    @Output() selectedOrderTypeChange = new EventEmitter<OrderTypeEnum>();

    orderTypes: OrderTypeEnum[];

    constructor(){
        this.orderTypes = [OrderTypeEnum.ProfileOnly, OrderTypeEnum.NonProfileOnly, OrderTypeEnum.Both]
    }

    getDisplayNameForEnum(orderType: OrderTypeEnum): string{
        switch (orderType){
            case OrderTypeEnum.NonProfileOnly:
                return 'Non-Profile Only';
            case OrderTypeEnum.ProfileOnly:
                return 'Profile Only';
            default:
                return orderType.toString();
        }
    }

    includeGabapentinChanged(newValue) {
        this.includeGabapentin = newValue;
        this.includeGabapentinChange.emit(newValue);
    }

    selectedOrderTypeChanged(newValue) {
        this.selectedOrderType = newValue;
        this.selectedOrderTypeChange.emit(newValue);
    }
}